<header class="header-spinner" [hidden]="!spinner">
  <button type="button" class="header-spinner--btnContainer" (click)="goBack()">
    <img
      src="../../../assets/icons/arrow_back_black.svg"
      alt="Ir a mis vehículos"
    />
    <p class="header-spinner--btnContainer__text">
      {{ 'btnReturn' | i18next | uppercase }}
    </p>
  </button>
</header>
<div
  style="width: 100%; display: flex; justify-content: center; min-height: 80vh"
>
  <div class="detail">
    <div>
      <header class="header" [hidden]="spinner">
        <button type="button" class="header--btnContainer" (click)="goBack()">
          <img
            src="../../../assets/icons/arrow_back_black.svg"
            alt="Ir a mis vehículos"
          />
          <p class="header--btnContainer__text">
            {{ 'btnReturn' | i18next | uppercase }}
          </p>
        </button>
      </header>
      <main class="content" [hidden]="spinner || errorDetail">
        <div class="content--header">
          <div class="d-flex flex-column">
            <h2 class="content--header__title">
              {{ 'detailRequest' | i18next }} {{ vehicleShowId }}
            </h2>
            <button
              *ngIf="isCarpool()"
              class="printButton"
              mat-button
              (click)="printButton()"
            >
              {{ 'printButton' | i18next }}
            </button>
          </div>
          <app-status-stepper
            *ngIf="
              orderInfo?.requestStatus !== requestStatusEnum.ACTIVE &&
              orderInfo?.requestStatus !== requestStatusEnum.CLOSED_REQUEST &&
              orderInfo?.requestStatus !== requestStatusEnum.CANCELLED &&
              orderInfo?.requestStatus !== requestStatusEnum.REJECTED
            "
            [steps]="statusSteps"
            [currentStep]="currentStatusStep"
          ></app-status-stepper>
        </div>

        <div
          *ngIf="
            orderInfo?.requestType !== requestTypeEnum.dotArr &&
            orderInfo?.requestType !== requestTypeEnum.campaigns &&
            orderInfo?.requestType !== requestTypeEnum.leasing
          "
        >
          <div class="card">
            <app-request-data
              id="requestData"
              [requestData]="orderInfo"
            ></app-request-data>
          </div>

          <div
            class="card"
            *ngIf="orderInfo?.controller || orderInfo?.delegatedApprover"
          >
            <app-approvers
              id="approvers"
              [controller]="orderInfo?.controller"
              [authorizer]="orderInfo?.delegatedApprover"
              [requestStatus]="orderInfo?.requestStatus"
              [requestNumber]="orderInfo?.requestNumber || orderInfo?.id"
              [extraData]="orderInfo"
              [type]="orderInfo?.requestType"
              [loanType]="orderInfo?.loanDataDTO?.loanType"
              [isModify]="isModifyMode"
              [isDetail]="isDetail"
              (selectionAuthorizers)="onSelectionAuthorizers($event)"
            ></app-approvers>
          </div>

          <div class="card" *ngIf="!spinner && !errorDetail && orderInfo?.user">
            <app-info-petitioner
              id="petitionerInfo"
              [user]="orderInfo?.user"
              [isDetail]="true"
              [orderInfo]="orderInfo"
            ></app-info-petitioner>
          </div>

          <div
            class="card"
            *ngIf="
              !spinner &&
              orderInfo?.requestType !== requestTypeEnum.proyect &&
              !errorDetail
            "
          >
            <app-car-configurator
              id="newCar"
              [summaryRequest]="'summaryRequest'"
              [vehicleInfoData]="orderInfo?.newVehicleDTO"
              [stockVehicleData]="orderInfo?.stockVehicleDTO"
              [loanData]="orderInfo?.loanDataDTO"
              [vehicle]="orderInfo.vehicle"
              [isDetail]="true"
              [isModify]="isModifyMode"
              [extraData]="orderInfo"
              (getDetailEmitter)="getDetailLoan()"
            >
            </app-car-configurator>
          </div>

          <div
            class="card"
            *ngIf="orderInfo?.requestType === requestTypeEnum.loan"
          >
            <app-driver-data
              id="driverData"
              [driverData]="orderInfo?.loanDataDTO.driver"
              [loanData]="orderInfo?.loanDataDTO"
              [extraData]="orderInfo"
              [isModify]="isModifyMode"
              (getDetailEmitter)="getDetailLoan()"
            ></app-driver-data>
          </div>

          <div
            class="card d-flex flex-row gap-2"
            *ngIf="
              orderInfo?.requestType === requestTypeEnum.function &&
              orderInfo?.checkMartorell != null
            "
          >
            <span class="text-black fw-bold">{{
              'deliveryLocationText' | i18next
            }}</span>
            <span class="text-muted">{{
              orderInfo?.checkMartorell
                ? ('btnYes' | i18next)
                : ('btnNo' | i18next)
            }}</span>
          </div>

          <div
            class="card"
            *ngIf="orderInfo?.requestType !== requestTypeEnum.proyect"
          >
            <app-delivered-vehicle
              id="deliveredCar"
              [deliveredVehicle]="orderInfo?.vehicle"
              [vehicleRegistrationData]="orderInfo?.vehicleRegistrationDataDTO"
              [appraisalValue]="orderInfo?.appraisalValue"
            ></app-delivered-vehicle>
          </div>

          <div class="card" *ngIf="orderInfo?.replacedVehicle">
            <app-replaced-data
              id="substituCar"
              [replacedData]="orderInfo?.replacedVehicle"
            ></app-replaced-data>
          </div>

          <div class="card" *ngIf="orderInfo?.requestType === 'PROJECT'">
            <app-project-data
              id="projectData"
              [projectData]="orderInfo"
              [isModify]="isModifyMode"
              [controller]="controller"
              [delegatedApprover]="delegatedApprover"
            ></app-project-data>
          </div>

          <app-tracking
            [oldStatus]="orderInfo?.previousRequestStatus"
            id="status"
          ></app-tracking>

          <div class="card" *ngIf="orderInfo?.bookingData">
            <app-booking-vehicle-data
              id="bookingData"
              [bookingData]="orderInfo?.bookingData"
            ></app-booking-vehicle-data>
          </div>
        </div>

        <app-detail-leasing-request
          id="campaign"
          *ngIf="
            !spinner &&
            (orderInfo?.requestType === requestTypeEnum.dotArr ||
              orderInfo?.requestType === requestTypeEnum.campaigns ||
              orderInfo?.requestType === requestTypeEnum.leasing) &&
            !errorDetail
          "
          [orderInfo]="orderInfo"
          [car]="car"
          [additionalInfo]="orderInfo?.contactInfo"
        >
        </app-detail-leasing-request>
      </main>
      <div *ngIf="spinner" class="d-flex justify-content-center">
        <div class="text-center spinner-container" [hidden]="!spinner">
          <div class="spinner-border spinner" role="status"></div>
        </div>
      </div>
    </div>
    <div id="error-message" *ngIf="errorDetail">
      <p>{{ 'detailErrorMessage' | i18next }}</p>
    </div>
  </div>
</div>
